import {styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import {ColumnDef} from "../index";
import React from "react";

interface SimpleTableProps<T> {
    columnDefs: ColumnDef<T>[];
    renderActions?: (item: T) => JSX.Element;
    entries: T[];
}

const StyledTableRow = styled(TableRow)(({theme}) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));

function SimpleTable<T>({columnDefs, entries, renderActions}: SimpleTableProps<T>) {
    return (
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        {columnDefs.map((head, index) => (
                            <TableCell align={head.align} key={`th_${String(head.fieldName)}${index}`}>
                                {head.label}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {entries.map((item) => {
                        return (
                            <StyledTableRow>
                                {columnDefs.map((column: ColumnDef<T>) => (
                                    <TableCell align={column.align} key={String(column.fieldName)}>
                                        {column.formatCellText
                                            ? String(
                                                  column.formatCellText({cellValue: item[column.fieldName], row: item})
                                              )
                                            : column.cellContentNode
                                            ? column.cellContentNode({cellValue: item[column.fieldName], row: item})
                                            : String(item[column.fieldName])}
                                    </TableCell>
                                ))}
                                {renderActions && renderActions(item)}
                            </StyledTableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default SimpleTable;
